export const CustomerColumns = [
  {
    id: "actions",
    title: "Actions",
    type: "entity-menu",
  },
  {
    id: "name",
    title: "Name",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "contact2",
    title: "Contact 2",
  },
  {
    id: "ref",
    title: "Ref",
  },
  {
    id: "page_no",
    title: "Page No",
  },
  {
    id: "address",
    title: "Address",
  },
  {
    id: "total",
    title: "Total",
  },
  {
    id: "opening_balance",
    title: "Opening Balance",
  },
  {
    id: "return_amount",
    title: "Return",
  },
  {
    id: "discount",
    title: "Discount",
  },
  {
    id: "recieved",
    title: "Paid",
  },
  {
    id: "recieveable",
    title: "Remaining",
  },
];
